import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  fill: "none",
  viewBox: "0 0 35 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      d: "M10.667 8.424 18 15.756l7.333-7.31a1.5 1.5 0 0 1 1.111-.444A1.666 1.666 0 0 1 28 9.557a1.47 1.47 0 0 1-.445 1.067L20.2 18l7.355 7.377c.29.28.45.667.445 1.067a1.666 1.666 0 0 1-1.556 1.555 1.5 1.5 0 0 1-1.11-.444L18 20.245l-7.31 7.31a1.5 1.5 0 0 1-1.112.444A1.666 1.666 0 0 1 8 26.422a1.47 1.47 0 0 1 .445-1.067L15.8 18l-7.377-7.376A1.47 1.47 0 0 1 8 9.557a1.666 1.666 0 0 1 1.556-1.555 1.5 1.5 0 0 1 1.111.422"
    }, null, -1)
  ])))
}
export default { render: render }